<template>
	<div class="card">
		<div class="header">
			<h3>Loan Program Details</h3>
		</div>
		<div class="item">
			<span class="label">Product</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.program?.productName || 'N/A' }}</span>
		</div>
		<div class="item">
			<span class="label">Program</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.programName }}</span>
		</div>
		<div class="item">
			<span class="label">Alt Code</span>
			<span class="dots"></span>
			<span class="value">{{ loanDetails.loan?.programAltCode || 'N/A' }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { LoanDetails } from '@/models/loans';
	import { defineProps } from 'vue';

	defineProps<{
		loanDetails: LoanDetails;
	}>();
</script>
